import { useRouter } from 'next/router';
import { getWPLocale, WPLocale } from '../utils/localePath';

export const useGetCurrentLocale = (): WPLocale => {
  const { locale } = useRouter();

  return getWPLocale(locale);
};
